import React, { useEffect, useRef, useState } from "react"
import { Navigation } from "@kit/design/navigation"
import { Hint } from "@kit/design/hint"
import { CountBadge } from "@kit/design/count-badge"
import { SUBSCRIBER_EXPORT_REQUESTED_EVENT } from "./notifications-events"

const EXPORT_HINT_ID = "subscriber-export"
const EXPORT_HINT_TIMEOUT_MS = 10000

// The footer Notifications item, plus the Hint that points at it after a
// subscriber export is requested. The export runs in a separate React root and
// signals via a window event; the listener runs unconditionally so an event
// fired before the item mounts still surfaces the hint once it's there to
// anchor to.
export function NotificationsNavItem({
  leading,
  unseenCount,
  hasTopics,
  onOpen
}) {
  const anchorRef = useRef(null)
  const [hintPending, setHintPending] = useState(false)

  useEffect(() => {
    const queueHint = () => setHintPending(true)
    window.addEventListener(SUBSCRIBER_EXPORT_REQUESTED_EVENT, queueHint)
    return () =>
      window.removeEventListener(SUBSCRIBER_EXPORT_REQUESTED_EVENT, queueHint)
  }, [])

  useEffect(() => {
    if (!hintPending || !anchorRef.current) return
    Hint.show({
      id: EXPORT_HINT_ID,
      title: "Your subscribers are being exported.",
      description:
        "You can review the export progress and access the export in the Notifications menu.",
      anchor: anchorRef.current,
      position: "right",
      timeout: EXPORT_HINT_TIMEOUT_MS
    })
    setHintPending(false)
  }, [hintPending, hasTopics])

  if (!hasTopics) return null

  const handleClick = () => {
    Hint.close(EXPORT_HINT_ID)
    onOpen()
  }

  return (
    <Navigation.Item
      leading={leading}
      label="Notifications"
      trailing={unseenCount > 0 ? <CountBadge count={unseenCount} /> : null}
      render={<button type="button" ref={anchorRef} onClick={handleClick} />}
    />
  )
}
